import { TStandardGeographyParams } from "api/getStandardGeographies";

export const buildGeographyCacheKey = ({
  type,
  parentLayer,
  parentId,
}: TStandardGeographyParams): string =>
  [type, parentLayer, parentId].filter(Boolean).join(":");
